import { format } from 'date-fns'
import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../lib/redux/hook'
import { SortIcon } from '../../../ui/icons/sortIcon'
import { SpinnerComponent } from '../../../ui/molecules/spinner/index'
import { ConfirmModal } from '../../../ui/organisms/confirmModal'
import { ErrorPopup } from '../../../ui/organisms/errorPopup'
import { SuccessPopup } from '../../../ui/organisms/successPopup'
import { createPaymentWithId, findAllPayments, setCreatePaymentStatus } from './slice'
import { Pills } from '../../../ui/molecules/pills'

export function PurchaseHistory() {

    const dispatch = useAppDispatch()

    const authState = useAppSelector(state => state.auth)
    const customerState = useAppSelector(state => state.customer)
    const paymentState = useAppSelector(state => state.payment)

    const [confirm, setConfirm] = useState(false)
    const [sorted, setSorted] = useState(false)

    useEffect(() => {
        if (paymentState.createPaymentWithIdStatus === 'successfully' || paymentState.createPaymentWithIdStatus === 'failed') {
            const id = setTimeout(() => {
                dispatch(findAllPayments({ ...paymentState.findAllFilters, customerId: window.location.pathname.split('/')[2] }))
            }, 300);
            return () => clearTimeout(id)
        }
    }, [paymentState.createPaymentWithIdStatus])

    if (paymentState.findAllPaymentStatus === 'loading') {
        return (
            <div className=' flex justify-center items-center h-full flex-grow'>
                <SpinnerComponent size={30} />
            </div>)
    }

    return (
        <div>
            <SuccessPopup message='Pagamento creato con successo!' active={paymentState.createPaymentWithIdStatus === 'successfully'} close={() => dispatch(setCreatePaymentStatus('idle'))} />
            <ErrorPopup message='Creazione pagamento fallita!' active={paymentState.createPaymentWithIdStatus === 'failed'} close={() => dispatch(setCreatePaymentStatus('idle'))} />
            <ConfirmModal open={confirm} handleClose={() => setConfirm(false)} title={"Creazione pagamento"}
                description={"Vuoi davvero creare un pagamento?"} labelDeny={"No"} labelConfirm={"Si"} actionConfirm={
                    () => {
                        dispatch(createPaymentWithId(customerState.selectedCustomer))
                        setConfirm(false)
                    }
                } />
            <div className='w-full flex flex-col gap-4 rounded-tr-xl rounded-tl-xl overflow-auto'>
                <div>
                    <table className="w-full mb-3">
                        <thead className="h-[56px] bg-neutral-100 font-semibold text-neutral-500 text-text-xs">
                            <tr>
                                <th className="text-left flex items-center gap-1">
                                    <div className="flex py-4 pl-4 gap-1">
                                        DATA
                                        <SortIcon onClick={() => {
                                            dispatch(findAllPayments({
                                                ...paymentState.findAllFilters,
                                                customerId: customerState.selectedCustomer,
                                                sortBy: 'created_at',
                                                sort: sorted ? -1 : 1
                                            }
                                            ))
                                            setSorted(prev => !prev)
                                        }}
                                            size={'20'} color={''} />
                                    </div>
                                </th>
                                {paymentState.findAllPaymentResponse && paymentState.findAllPaymentResponse?.payments?.length > 0 &&
                                    <>
                                        <th className="text-left">
                                            <div className="flex py-4 px-4 gap-1">
                                                IMPORTO (i.e.)
                                            </div>
                                        </th>
                                        <th className="text-left">
                                            <div className="flex py-4 px-4 gap-1">
                                                ESITO
                                            </div>
                                        </th>
                                        <th className="text-left">
                                            <div className="flex py-4 px-4 gap-1">
                                                STATO FATTURA
                                            </div>
                                        </th>
                                        <th className="text-left">
                                            <div className="flex py-4 px-4 gap-1">
                                                TDM APPLICATO
                                            </div>
                                        </th>
                                        <th className="text-left">
                                            <div className="flex py-4 px-4 gap-1">
                                                METODO
                                            </div>
                                        </th>
                                    </>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {
                                paymentState.findAllPaymentResponse && (
                                    paymentState.findAllPaymentResponse.payments.length === 0 ?
                                        <tr className="bg-white h-[56px] border-b-[1px] border-b-neutral-100 w-full">
                                            <td className="py-4 px-4 text-text-sm font-medium text-neutral-500">
                                                Nessun risultato trovato!
                                            </td>
                                        </tr>
                                        :
                                        paymentState.findAllPaymentResponse.payments.map((item, index) =>
                                            <tr
                                                className="bg-white h-[56px] border-b-[1px] border-b-neutral-100 text-text-sm text-center font-semibold text-neutral-600"
                                                key={index}
                                            >
                                                <td className="py-4 px-4 text-start">
                                                    {format(new Date(item.createdAt), 'dd/MM/yy')}
                                                </td>
                                                <td className="py-4 px-4 text-neutral-800 text-start ">
                                                    {(item.amount / 1.22).toFixed(2)} €
                                                </td>
                                                <td className="py-4 px-4 text-start">
                                                    {item.payment_status ?
                                                        <Pills size={'sm'} label={'Successo'} outline={false} emphasis={false} color={'green'} /> :
                                                        <Pills size={'sm'} label={'Fallito'} outline={false} emphasis={false} color={'red'} />
                                                    }
                                                </td>
                                                <td className="py-4 px-4 text-start">
                                                    {item.invoice_status ?
                                                        <Pills size={'sm'} label={'Inviata'} outline={false} emphasis={false} color={'green'} /> :
                                                        <Pills size={'sm'} label={'Invio fallito'} outline={false} emphasis={false} color={'red'} />}
                                                </td>
                                                <td className="py-4 px-4 text-start ">{item.markup_rate_applied}</td>
                                                <td className="py-4 px-4 text-start ">{item.stripe_payment_method}</td>
                                            </tr>
                                        )
                                )
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}
